<template>
    <div class="wlx-adopt-school">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">站点管理</span>
            </div>
            <div class="fr btn-right">
                 <el-form :inline="true" size="small">
                    <div class="dd-search-form-news">
                        <el-form-item>
                            <el-input v-model="searchName" placeholder="请输入专家名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="yk-wrap-fixeds clearfix">
            <!-- 新增/修改站点 -->
            <el-dialog :title="tisi" v-if="addNewNoticeVisible" :visible.sync="addNewNoticeVisible" :before-close="cancel" :append-to-body="true" width="70%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="160px">
                        <el-form-item label="专家名称" prop="title">
                            <el-input v-model="name"></el-input>
                        </el-form-item>
                        <el-form-item label="照片">
                            <imageUpload :url="urlAliyunOSS" :files.sync="cover" format="image"></imageUpload>
                        </el-form-item>
                        <el-form-item label="职务" prop="jobPosition">
                            <el-input v-model="jobPosition"></el-input>
                        </el-form-item>
                        <el-form-item label="介绍" prop="introduce">
                            <el-input v-model="introduce"></el-input>
                        </el-form-item>
                        <el-form-item label="是否为展示">
                            <el-radio-group v-model="isShow">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addNewNoticeVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addOrEditExpert()">确 定</el-button>
                </span>
            </el-dialog>
            <div>
                <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange">
                    <el-table-column prop="id" type="selection" width="55"></el-table-column>
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="jobPosition" label="职务"></el-table-column>
                    <el-table-column prop="introduce" label="介绍"></el-table-column>
                    <el-table-column prop="isShow" label="是否展示" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isShow == 0">不是</span>
                            <span v-if="scope.row.isShow == 1">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <el-button size="mini" class="el-icon-edit" @click="edit(scope.row)" type="primary" title="编辑"></el-button>
                            </el-tooltip>

                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <el-button size="mini" type="danger" class="el-icon-delete" @click="deleteExpert(scope.row.id)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="news-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            tisi: "",
            isKZ: "",
            /* -----------添加/修改弹框参数------------ */
            id: "",
            name: "",
            cover: "",
            jobPosition: "",
            introduce: "",
            isShow: 0,
            /* --------------------------------------- */
            ids: [],
            value: "",
            siteType: "",
            schoolProvince: "",
            schoolCity: "",
            // excel导入
            uploadUrl: "/api/XOrg/School/uploadExcel",
            errorList: [],
            fileList: [],
            ImportDialogVisible: false,
            // exportExcelStu:''
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
            searchName:""
        };
    },
    components: {
      imageUpload
    },
    created() {
        this.school = this.$store.state.auth.userName;
        this.getExpertList();
    },
    computed: {},
    methods: {

        getExpertList() {
            var that = this;
            this.$http
                .post("/api/XOrg/Expert/getExpertList", {
                    name: this.searchName,
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        that.list = rst.list;
                        that.total = rst.pagination.totalCount;
                        that.pageSize = rst.pagination.pageSize;
                        that.pageIndex = rst.pagination.pageIndex;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.pageIndex = page;
            this.getExpertList();
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this.getExpertList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },
        addOrEditExpert() {
            var that = this;
            this.$http
                .post("/api/XOrg/Expert/addOrEditExpert", {
                    id: that.id,
                    name: that.name,
                    cover: that.cover,
                    jobPosition: that.jobPosition,
                    introduce: that.introduce,
                    isShow: that.isShow
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.$message.success(rst.msg);
                        that.getExpertList();
                        that.addNewNoticeVisible = false;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        add() {
            this.tisi = "新增专家";
            this.addNewNoticeVisible = true;
            this.id = "";
            this.name = "";
            this.cover = "";
            this.jobPosition = "";
            this.introduce = "";
            this.isShow = "";
        },
        edit(row) {
            this.tisi = "编辑专家";
            this.addNewNoticeVisible = true;
            this.id = row.id;
            this.name = row.name;
            this.cover = row.cover;
            this.jobPosition = row.jobPosition;
            this.introduce = row.introduce;
            this.isShow = row.isShow;
        },
        cancel() {
            this.addNewNoticeVisible = false;
        },
        deleteExpert(id) {
            this.$confirm("此操作将删除该专家, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var that = this;
                    this.$http
                        .post("/api/XOrg/Expert/deleteExpert", {
                            ids: id,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message.success(rst.msg);
                                that.getExpertList();
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        search() {
            this.pageIndex = 1;
            this.getExpertList();
        },
        deleteAll() {
            if (this.ids.length === 0) {
                this.$message({
                    showClose: true,
                    message: "请选择站点",
                    type: "warning",
                });
                return false;
            }
            this.$confirm("此操作将删除所选专家, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var that = this;
                    this.$http
                        .post("/api/XOrg/Expert/deleteExpert", {
                            ids: that.ids,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message.success(rst.msg);
                                this.getExpertList();
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
};
</script>

<style lang="scss">
.wlx-adopt-school {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
